import * as z from 'zod';
import { createEventSchema } from 'hx-analytics';
export var eargoCustomEventSchemas = {
    test_start: createEventSchema({
        attribution: z.record(z.unknown()),
    }, 'heardigits_widget_test_start'),
};
